import { useForm } from "react-hook-form";
import useFormField from "../hooks/useFormField";
import CloseIcon from "@mui/icons-material/Close";
import Button from "@mui/material/Button";
import React from "react";
import { API_BASE, fetchJson } from "../utils";
import SearchDropdown from "./SearchDropdown";
async function loadUsers(query, page, signal) {
  const param = /^\d+$/.test(query)
    ? `discogs_id=${query}`
    : `username=${encodeURIComponent(query)}`;
  const data = await fetchJson(`${API_BASE}/admin/users/search/?${param}`, {
    credentials: "include",
    signal,
  });
  return Array.isArray(data?.results)
    ? data.results
    : Array.isArray(data)
      ? data
      : [];
}
const userLabel = (user) => String(user.username || user.discogs_id);
export default function UserSearchDropdown({
  onAdd,
  onRemove,
  value,
  onChange,
}) {
  const form = useForm({
    defaultValues: {
      selectedUsers: [],
    },
    mode: "onChange",
  });
  const [selectedUsers, setSelectedUsers] = useFormField(form, "selectedUsers");
  return (
    <div>
      <SearchDropdown
        value={value}
        onChange={onChange}
        clearOnSelect
        label="Search users"
        placeholder="Search users..."
        loadPage={loadUsers}
        getKey={(user) => user.discogs_id}
        getLabel={userLabel}
        onSelect={(user) => {
          if (
            selectedUsers.some(
              (selected) => selected.discogs_id === user.discogs_id,
            )
          )
            return;
          setSelectedUsers((previous) => [...previous, user]);
          onAdd?.(user);
        }}
        renderResult={(user) => (
          <div className="album-search-info">
            <div className="title">{userLabel(user)}</div>
            {user.username && (
              <div className="artist">Discogs ID: {user.discogs_id}</div>
            )}
          </div>
        )}
      />
      <div className="selected-users">
        {selectedUsers.map((user) => (
          <Button
            key={user.discogs_id}
            type="button"
            className="filter-tag"
            aria-label={`Remove ${userLabel(user)}`}
            onClick={() => {
              setSelectedUsers((previous) =>
                previous.filter(
                  (selected) => selected.discogs_id !== user.discogs_id,
                ),
              );
              onRemove?.(user.discogs_id);
            }}
          >
            {userLabel(user)}
            <CloseIcon />
          </Button>
        ))}
      </div>
    </div>
  );
}
